"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_TOURNAMENT_ANNOUNCEMENT_LENGTH = void 0;
exports.MAX_TOURNAMENT_ANNOUNCEMENT_LENGTH = 2000;
//# sourceMappingURL=max-tournament-announcement-length.js.map